export function useCSRF(): string | undefined {
    return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
}
